import { useState } from "react";
import { selectLanguage } from "../../data/languages/language.manager";

export const useLanguage = () => {
  const [language, setLanguage] = useState(selectLanguage("en"));
  const changeLanguage = (newLanguage: "en" | "fr") =>
    setLanguage(selectLanguage(newLanguage));

  return { language, changeLanguage };
};
